module.exports = __webpack_public_path__ + "static/media/mcap.46e5f0a3.svg";